
export interface PaymentusPaymentOption {
  key: string;
  category: string;
  description: string;
  icon?: string;
  iconTemplate: HTMLElement | string;
}

export const PaymentusPaymentOptions: PaymentusPaymentOption[] = [
  { key: 'debit-credit-card', category: 'CC ', description: 'Debit/Credit Card', iconTemplate: `
    <img src="assets/images/visa.png" />
            <img src="assets/images/masterCard.png" />
            <img src="assets/images/americanExpress.png" />
            <img src="assets/images/discover.png" />
  ` },
  /*{ key: 'bank-account', category: 'DD', description: 'Checking/Savings Account', icon: 'account_balance', iconTemplate: `<mat-icon>account_balance</mat-icon>` },*/
  { key: 'google-pay', category: 'GP', description: 'GooglePay', iconTemplate: `<img src="assets/images/google-pay.svg" width="72px" height="52px" />` },
  { key: 'apple-pay', category: 'AP', description: 'ApplePay', iconTemplate: `<img src="assets/images/apple-pay.svg" width="72px" height="31px" />` },
];



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/payment.options.ts